import React from "react";
import { Input } from "reactstrap";
import "./inputNumberCustomArrows.css";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
// IMPORTANT !!! FOR ONLY NUMBER INPUTS
const FormikInputNumberCustomArrows = ({ field, form, ...props }) => {
  const haveValueStyles = () => {
    const result = props.className || "";
    if (props.disabled) {
      return result + " disabled";
    }
    
    if (field && field.value) {
      return result.concat(" background-have-value");
    }

    return result;
  };

  const increment = () => {
    form.setFieldValue(field.name, field.value + 1);
  };

  const decrement = () => {
    form.setFieldValue(field.name, field.value - 1);
  };

  if (props.disabled) {
    return (
      <div className="number-input-box">
        <IoIosArrowUp
          color="#9A9A9A"
          size={22}
          className="down-arrow-number-input disabled"
        />
        <Input {...field} {...props} className={haveValueStyles()} />
        <IoIosArrowDown
          color="#9A9A9A"
          size={22}
          className="up-arrow-number-input disabled"
        />
      </div>
    );
  }

  return (
    <div className="number-input-box">
      <IoIosArrowUp
        onClick={increment}
        color="#9A9A9A"
        size={22}
        className="down-arrow-number-input"
      />
      <Input {...field} {...props} className={haveValueStyles()} />
      <IoIosArrowDown
        onClick={decrement}
        color="#9A9A9A"
        size={22}
        className="up-arrow-number-input"
      />
    </div>
  );
};

export default FormikInputNumberCustomArrows;



// WEBPACK FOOTER //
// ./src/components/formik/settings/InputNumberCustomArrows.jsx